// Load the YouTube IFrame API once
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
document.head.appendChild(tag);

const players = []; // Track all preview players

// Called when the API is ready
window.onYouTubeIframeAPIReady = () => {
	document.querySelectorAll('[data-youtube-preview]').forEach(initVideoEmbed);
};

document.addEventListener('DOMContentLoaded', () => {
	// If the API is already loaded before DOMContentLoaded fires
	if (window.YT && window.YT.Player) {
		document.querySelectorAll('[data-youtube-preview]').forEach(initVideoEmbed);
	}
});

function initVideoEmbed(wrapper) {
	const previewId = wrapper.dataset.youtubePreview;
	const modalId = wrapper.dataset.youtubeModal;
	const videoId = wrapper.dataset.youtubeId;

	const previewContainer = wrapper.querySelector('.preview-player');
	const openBtn = wrapper.querySelector('.open-modal');
	const closeBtn = wrapper.querySelector('.close-modal');
	const modal = document.getElementById(modalId);
	const modalContent = modal.querySelector('.modal-container');

	let previewPlayer, modalPlayer;

	const openBtnDisplay = openBtn.style.display;
	openBtn.style.display = "none";
	// Create preview player
	previewPlayer = new YT.Player(previewContainer, {
		videoId,
		height: '390',
		width: '640',
		playerVars: {
			autoplay: 1,
			mute: 1,
			controls: 0,
			modestbranding: 1,
			rel: 0,
		},
		events: {
		  onReady: (event) => {
			event.target.playVideo();
			openBtn.addEventListener('click', () => {
			  modal.showModal();

			  const playerDivId = `full-player-${videoId}`;
			  let fullPlayerDiv = document.getElementById(playerDivId);

			  if (!fullPlayerDiv) {
				fullPlayerDiv = document.createElement('div');
				fullPlayerDiv.id = playerDivId;
				fullPlayerDiv.classList.add('modal-player');
				fullPlayerDiv.style.width = '640px';
				fullPlayerDiv.style.height = '390px';
				modalContent.insertBefore(fullPlayerDiv, closeBtn);
			  }

			  if (!modalPlayer) {
				previewPlayer.pauseVideo();

				modalPlayer = new YT.Player(playerDivId, {
				  videoId,
				  height: '390',
				  width: '640',
				  playerVars: {
					autoplay: 1,
					mute: 0,
					controls: 1,
					modestbranding: 1,
					rel: 0,
				  },
				  events: {
					onReady: (event) => event.target.playVideo(),
				  },
				});
			  } else if (modalPlayer && modalPlayer.playVideo) {
				previewPlayer.pauseVideo();
				modalPlayer.playVideo();
			  }

			  closeBtn.addEventListener('click', () => {
				modal.close();
				previewPlayer.playVideo();
			  });

			  modal.addEventListener('close', () => {
				if (modalPlayer && modalPlayer.destroy) {
				  modalPlayer.destroy();
				  modalPlayer = null;
				}

				const playerDiv = modalContent.querySelector(`#full-player-${videoId}`);
				if (playerDiv) playerDiv.remove();
			  });

			  modal.addEventListener('click', (event) => {
				const rect = modal.getBoundingClientRect();
				if (
				  event.clientY < rect.top ||
					event.clientY > rect.bottom ||
					event.clientX < rect.left ||
					event.clientX > rect.right
				) {
				  modal.close();
				  previewPlayer.playVideo();
				}
			  });
			});
			openBtn.style.display = openBtnDisplay;
		  },

		  onStateChange: (event) => {
			if (event.data === YT.PlayerState.ENDED) {
				event.target.seekTo(0);
				event.target.playVideo();
			}
		  },
		},
	});
}
